import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';
import {
  DateFilterStrategy,
  DateFilterStrategyLabel,
  ReportType,
} from 'src/app/utils/reportType';
import { SelectorData } from 'src/app/utils/selectorDataType';

@Component({
  selector: 'app-download-report-modal',
  templateUrl: './download-report-modal.component.html',
  styleUrls: ['./download-report-modal.component.scss'],
})

/**
 * Download Report modal
 */
export class DownloadReportModalComponent {
  @Output() submitClicked = new EventEmitter<any>();
  rangeOptions: SelectorData[] = [
    {
      label: DateFilterStrategyLabel.SIX_MONTHS,
      value: DateFilterStrategy.SIX_MONTHS,
    },
    {
      label: DateFilterStrategyLabel.TWELVE_MONTHS,
      value: DateFilterStrategy.TWELVE_MONTHS,
    },
    {
      label: DateFilterStrategyLabel.TWENTY_FOUR_MONTHS,
      value: DateFilterStrategy.TWENTY_FOUR_MONTHS,
    },
    {
      label: DateFilterStrategyLabel.DATE_RANGE,
      value: DateFilterStrategy.DATE_RANGE,
    },
  ];

  selectedOption: string | null = null;
  selectedDateRange: { start: Date | null; end: Date | null } | null = null;
  isDisplayDateRange: boolean = false;
  isDisabled: boolean = true;
  isDateRangeDirty: boolean = false;

  /**
   * @constructor
   */
  constructor(
    public dialogRef: MatDialogRef<DownloadReportModalComponent>,
    // from the data below, the type/title of the modal can be extracted.
    @Inject(MAT_DIALOG_DATA) public data: ReportType
  ) {
    if (data === ReportType.TRANSACTIONS) {
      this.rangeOptions = this.rangeOptions.filter(
        (option) => option.value !== DateFilterStrategy.TWENTY_FOUR_MONTHS
      );
    }
    if (data == ReportType.CENSUS) {
      this.rangeOptions.push({
        label: DateFilterStrategyLabel.ALL_TIME,
        value: DateFilterStrategy.ALL_TIME,
      });
    }
  }

  /**
   * Action to close the dialog
   */
  onSuccessClick() {
    this.dialogRef.close({
      option: this.selectedOption,
      dateRange: this.selectedDateRange,
    });
  }

  /**
   * Action to close the dialog
   */
  onCloseClick() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }

  /**
   *
   * @param {string} option
   */
  onOptionSelected(option: string) {
    this.selectedOption = option;
    if (option === DateFilterStrategy.DATE_RANGE) {
      this.isDisplayDateRange = true;
      this.isDisabled = true;
    } else {
      this.isDisplayDateRange = false;
      this.isDisabled = false;
    }
  }

  /**
   *
   * @param {FormGroup} dateRange
   */
  onDateRangeSelected(
    dateRange: { start: Date | null; end: Date | null } | null
  ) {
    this.selectedDateRange = {
      start: dateRange?.start!,
      end: dateRange?.end!,
    };
    // if the start or end date is null, disable the button
    this.isDisabled = !dateRange?.start || !dateRange?.end;
    this.isDateRangeDirty = true;
  }

  /**
   * Checks if the date range as touched and is invalid
   * @return {boolean} isDateRangeInvaid
   */
  isDateRangeInvalid(): boolean {
    const isInvalid =
      !this.selectedDateRange?.start || !this.selectedDateRange.end;
    return this.isDisplayDateRange && this.isDateRangeDirty && isInvalid;
  }
}
